<template>
  <div id="vip">
    <ul>
      <li style="font-size: 25px;font-weight: bold;color:dodgerblue;">月费VIP<p style="font-size: 18px;font-weight: 200;color:black;"><br>￥9.9/30天 <br><br>专属高速下载通道<br><br>免费下载资源30天<br><br>VIP客服在线解答问题<br><br>官方新游戏抢先体验<br><br><el-button @click="linkuser" type="primary">点击加入</el-button><br><br><br></p></li>
      <li style="font-size: 25px;font-weight: bold;color:dodgerblue;">年费VIP<p style="font-size: 18px;font-weight: 200;color:black;"><br>￥50/360天 <br><br>专属高速下载通道<br><br>免费下载资源360天<br><br>VIP客服在线解答问题<br><br>官方新游戏抢先体验<br><br><el-button @click="linkuser" type="primary">点击加入</el-button><br><br><br></p></li>
      <li style="font-size: 25px;font-weight: bold;color:dodgerblue;">永久VIP<p style="font-size: 18px;font-weight: 200;color:black;"><br>￥129/终身 <br><br>专属高速下载通道<br><br>永久免费下载资源<br><br>VIP客服在线解答问题<br><br>官方新游戏抢先体验<br><br><el-button @click="linkuser" type="primary">点击加入</el-button><br><br><br></p></li>
    </ul>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  methods:{
    linkuser(){
      this.$notify({
        title: '警告',
        message: '当前支付系统维护,请联系QQ:34283063 加入VIP',
        type: 'warning',
        duration: 0
      });
    }
  },
}
</script>

<style scoped>
#vip{
  width: 66%;
  margin: 0 auto;
}
#vip li{
  float: left;
  /* border: solid 2px red; */
  background-color: aliceblue;
  width:25%;
  text-align: center;
  box-shadow: 0px 0px 5px 5px #e6e6e6;
  margin: 25px;
  padding-top: 20px;
  transition:all 0.2s;
}
#vip li:hover{
  transform: scale(1.1);
}
</style>
